import "./RichText.scss";
import React from "react";
import ReactMarkdown from "react-markdown";
import { useSelector } from "react-redux";
import { selectText } from "../../../translation/translationSlice";

const RichText = React.memo(({ value }) => {
  const t = useSelector(selectText);

  const md =
    typeof value === "string"
      ? t(value)
      : `${value.title && t(value.title) ? `# ${t(value.title)}\n\n` : ""}${
          value.subtitle && t(value.subtitle) ? `## ${t(value.subtitle)}\n\n` : ""
        }${value.body && t(value.body) ? `${t(value.body)}\n` : ""}`;
  
  return (
    <div className="RichText">
      <ReactMarkdown source={md} />
    </div>
  );
});

export default RichText;
